import routeName from '../constant';
import { guideRoutes } from '@/utils/guideRoutes';
import aplCatlCode from '@/json/aplCatlCode';
import codeList from '@/json/codeList';

const code = codeList.PON4300;
const aplCatl = aplCatlCode.PON4300;

export const routesLoanApply = [{
    path: 'select-account',
    name: routeName.LOAN_SELECT_ACCOUNT,
    component: () => import('@/views/Pon4300/selectAccount/Index.vue'),
    meta: { auth: true, metaTitle: '借款選擇帳號', leaveAlert: true, code, unableBack: true },
    beforeEnter: (to, from, next) => {
        const whiteList = [routeName.EDIT_TEL_MAIL, routeName.LOAN_PROGRAM, routeName.CONFIRM_DATA];
        const guideRoute = guideRoutes(from, whiteList, true, aplCatl);
        next(guideRoute);
    },
}];

export const routesLoan = [
    {
        path: '/loan-term-one',
        name: routeName.LOAN_TERM_ONE,
        component: () => import('@/views/Pon4300/landingPage/Index.vue'),
        meta: { auth: true, metaTitle: '借款同意事項', leaveAlert: false, code },
        beforeEnter: (to, from, next) => {
            const whiteList = [routeName.HOME, routeName.SSO_PAGE, routeName.SSO_SCV, routeName.SSO_MOBILE];
            const guideRoute = guideRoutes(from, whiteList, true, aplCatl);
            next(guideRoute);
        },
    },
    {
        path: '/loan-term-two',
        name: routeName.LOAN_TERM_TWO,
        component: () => import('@/views/Pon4300/termTwo/Index.vue'),
        meta: { auth: true, metaTitle: '借款同意事項', leaveAlert: true, code, unableBack: true },
        beforeEnter: (to, from, next) => {
            const whiteList = [routeName.LOAN_TERM_ONE];
            const guideRoute = guideRoutes(from, whiteList, true, aplCatl);
            next(guideRoute);
        },
    },
    {
        path: '/loan-program',
        name: routeName.LOAN_PROGRAM,
        component: () => import('@/views/Pon4300/program/Index.vue'),
        meta: { auth: true, metaTitle: '保戶借款優惠利率專案', leaveAlert: true, code, unableBack: true },
    },
    {
        path: '/loan-program-documents',
        name: routeName.LOAN_PROGRAM_DOCUMENTS,
        component: () => import('@/views/Pon4300/programDocuments/Index.vue'),
        meta: { auth: true, metaTitle: '保戶借款優惠利率專案', leaveAlert: true, code, unableBack: true },
    },
];
